<mf-page title="Órdenes">
  <mf-row>
    <mf-order-grid [transferId]="transferId" />
  </mf-row>
</mf-page>
